import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAttributeField } from '../modules/attribute/actions';

/**
 * Ersetzt das frühere AttributeContext-Objekt eins zu eins (gleiche Feldnamen),
 * damit bestehende Konsumenten unverändert `attribute.xxx`/`attribute.setXxx(...)` nutzen können.
 *
 * Die Setter sind mit useCallback memoisiert, damit sie über Renders hinweg
 * referenzstabil bleiben - siehe useTreeState.js fuer die Begruendung
 * (sonst droht eine Endlosschleife, wenn ein Setter in einer Effekt-Dependency landet).
 */
export function useAttributeState() {
    const attribute = useSelector((state) => state.attribute);
    const dispatch = useDispatch();

    const setSelected = useCallback((value) => dispatch(setAttributeField('selected', value)), [dispatch]);
    const setDesc = useCallback((value) => dispatch(setAttributeField('desc', value)), [dispatch]);
    const setId = useCallback((value) => dispatch(setAttributeField('id', value)), [dispatch]);
    const setIfcType = useCallback((value) => dispatch(setAttributeField('ifcType', value)), [dispatch]);
    const setIsSelected = useCallback((value) => dispatch(setAttributeField('isSelected', value)), [dispatch]);

    return {
        selected: attribute.selected, setSelected,
        desc: attribute.desc, setDesc,
        id: attribute.id, setId,
        ifcType: attribute.ifcType, setIfcType,
        isSelected: attribute.isSelected, setIsSelected,
    };
}
